<!-- 大图+视频 -->
<template>
	<div>
		<video ref="v1" class="video" webkit-playsinline playsinline autoplay loop muted x-webkit-airplay="true">
			<source class="source" src="../assets/video/backvideo.mp4" type="video/mp4" />
		</video>
		<div ref="text1" class="w-100  cc" style=" z-index: 90;color: white;text-align: center;">
			<div>
				<transition name="fade">
					<div v-if="showword[0]" class="fontsize" style=" font-family: YouSheBiaoTiHei; 
						 
						-webkit-text-fill-color:transparent; 
						 -webkit-text-stroke:1px white; ">
						再小的星球</div>
				</transition>
				<transition name="fade2">
					<div v-if="showword[1]" class="fontsize"
						style="font-family: YouSheBiaoTiHei;font-style: italic;">
						在星链也能散发星光
					</div>
				</transition>

				<transition name="fade2">
					<div v-if="showword[2]" style="font-size: 14px; letter-spacing: 2px;text-transform :uppercase;">
						no matter how samall the planet isit can
						also emit starlight in fashion link</div>
				</transition>
				<!-- <div style="height: 100px;"></div> -->

			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'firstsceen',
		data() {
			return {
				showword: [false, false, false]
			}
		},
		methods: {


		},

		mounted() {
			/*
			为了视频地球原型完整，v1视频高宽比例固定不能拉伸，为了保证宽度满屏，高度有可能会大于首屏
			text1文字高度为首屏高度，
			所以吧(v1-text1)/2 的距离用作v1的高度，这样能做到居中
			*/
			var v1 = this.$refs.v1
			var text1 = this.$refs.text1
			v1.addEventListener('canplay', function(e) {
				console.log(v1.offsetHeight)
				text1.style.height = v1.offsetHeight + "px";
			})


			// console.log( v1.offsetHeight)
			// var height = (v1.offsetHeight - text1.offsetHeight) / 2 * -1;

			// if (text1.offsetWidth > text1.offsetHeight) {
			// 	if (height < 0) {
			// 		v1.style.marginTop = height + "px";
			// 	}

			// 	// alert("电脑屏" + height)
			// } else {
			// 	v1.style.marginTop = "-20px";
			// 	text1.style.height = v1.offsetHeight + "px";
			// 	var topsize = (v1.offsetHeight - 119) / 2
			// 	text1.style.marginTop = topsize + "px";
			// 	//alert("手机屏topsize：" + height)
			// }

			this.$set(this.showword, 0, true)
			this.$set(this.showword, 1, true)
			this.$set(this.showword, 2, true)
		}

	}
</script>


<style>
	@media (min-width: 1px) {
		.fontsize {
			font-size: 30px;
			letter-spacing: 5px;
		
		}
	}
	
	@media (min-width: 1000px) {
		.fontsize {
		font-size: 60px; 
		letter-spacing: 10px;
		
		}
	}
	
	
	.video {
		position: absolute;
		width: 100%;
		margin-bottom: auto;
		/* height: auto; */
		/* width: auto;   */
		/*加滤镜*/
		/* filter: blur(1px); //背景模糊设置 */
		/*-webkit-filter: grayscale(100%);*/
		/*filter:grayscale(100%); //背景灰度设置*/
		z-index: -11;
		object-fit: fill;
	}


	.fade-enter-active {
		transition: all 1.5s;
	}

	.fade-enter {
		opacity: 0;
		transform: translateY(-130px);
	}

	.fade2-enter-active {
		transition: all 1.5s;
	}

	.fade2-enter {
		opacity: 0;
		transform: translateY(130px);
	}
</style>
